/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Janja 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gakindo": ["Bukerera", "Bunyironko", "Kabusoro", "Kibonwa", "Rubona", "Rurumbya"],
  "Gashyamba": ["Burega", "Gatongo", "Gitovu", "Nyabikenke", "Rwampali"],
  "Gatwa": ["Buhanga", "Gitega", "Kinoko", "Murambi", "Mwanza", "Nyabushishiri", "Nyagisozi"],
  "Karukungu": ["Buhimbi", "Cyifuzo", "Gitaba", "Karama", "Mugandu", "Rugeshi", "Rusasa", "Rutake"]
};